module.exports = __webpack_public_path__ + "static/media/DEV00627-Bearbeitet-2.2b7e47d8.jpg";